import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    updateAndEnableFilter,
    sharedOwnershipSelector,
    auctionSelector,
    helpToBuySelector
} from '@zoopla/redux-reducer-filters';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';

export const SelectBuyingOptions: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: isSharedOwnership,
        label: isSharedOwnershipLabel,
        disabled: sharedOwnershipDisabled
    } = useSelector(sharedOwnershipSelector);

    const {
        selectedValue: auction,
        label: auctionLabel,
        disabled: auctionDisabled
    } = useSelector(auctionSelector);

    const {
        selectedValue: helpToBuy,
        label: helpToBuyLabel,
        disabled: helpToBuyDisabled
    } = useSelector(helpToBuySelector);

    const onChangeIsSharedOwnership = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'isSharedOwnership',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    const onChangeAuction = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'auction',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    const onChangeHelpToBuy = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'incentives',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    return (
        <>
            <SometimesInlineFiltersCheckBox
                label={auctionLabel}
                id="auction"
                data-testid="filters-modal-auction"
                checked={auction}
                onChange={onChangeAuction}
                disabled={auctionDisabled}
            />
            <SometimesInlineFiltersCheckBox
                label={isSharedOwnershipLabel}
                id="shared-ownership"
                data-testid="filters-modal-shared-ownership"
                checked={isSharedOwnership}
                onChange={onChangeIsSharedOwnership}
                disabled={sharedOwnershipDisabled}
            />
            <SometimesInlineFiltersCheckBox
                label={helpToBuyLabel}
                id={'help-to-buy'}
                data-testid="filters-modal-help-to-buy"
                checked={helpToBuy}
                onChange={onChangeHelpToBuy}
                disabled={helpToBuyDisabled}
            />
        </>
    );
};
